import { render, staticRenderFns } from "./CreatePublicCouncilBanner.vue?vue&type=template&id=682a7e9c&scoped=true&"
import script from "./CreatePublicCouncilBanner.vue?vue&type=script&lang=js&"
export * from "./CreatePublicCouncilBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreatePublicCouncilBanner.vue?vue&type=style&index=0&id=682a7e9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a7e9c",
  null
  
)

export default component.exports